const AGE_CONFIRMED_KEY = "ageConfirmed";

export const isAgeConfirmedForSession = () => {
  try {
    return sessionStorage.getItem(AGE_CONFIRMED_KEY) === "true";
  } catch (err) {
    return false;
  }
};

export const setAgeConfirmedForSession = () => {
  try {
    sessionStorage.setItem(AGE_CONFIRMED_KEY, "true");
  } catch (err) {
  }
};
